import { Position, Size } from '../find-postion-env';

const findTop = (
  containerRect: DOMRect | undefined,
  size: Size,
  triggerPosition: Position,
) => {
  let top = 0;

  if (window.innerHeight - triggerPosition.top < size.height) {
    top = window.innerHeight - size.height - 8;
  } else {
    top = triggerPosition.top;
  }

  if (!containerRect) return top;
  top -= containerRect.y;

  return top;
};

export default findTop;
